const sectionPadding = (
  { meta: { firstChild, lastChild } },
  { css_padding_left, css_padding_right, css_padding_top, css_padding_bottom }) => {
  return {
    paddingTop: css_padding_top && `${css_padding_top}px`,
    paddingBottom: css_padding_bottom && `${css_padding_bottom}px`,
    paddingLeft: (firstChild && css_padding_left) && `${css_padding_left}px`,
    paddingRight: (lastChild && css_padding_right) && `${css_padding_right}px`
  };
}

export default sectionPadding;
